/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.18.0-39-gcbbeb71b-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RoleDataRequest interface.
 */
export function instanceOfRoleDataRequest(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
export function RoleDataRequestFromJSON(json) {
    return RoleDataRequestFromJSONTyped(json, false);
}
export function RoleDataRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}
export function RoleDataRequestToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'description': value['description'],
    };
}
